module.exports = __webpack_public_path__ + "img/1577.76676553.gif";